import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TabConfig } from '../../model/tab-config.model';

/**
 * * Componente de abas padrão para o Apolo.
 */
@Component({
  selector: 'ui-generic-tab',
  templateUrl: './generic-tab.component.html',
  styleUrls: ['./generic-tab.component.scss']
})
export class GenericTabComponent implements OnInit {

  /**
   * * Array com a configuração das abas.
   */
  @Input() buttons: Array<TabConfig> = [];

  /**
   * * Cor de fundo para o componente (cinza ou branco).
   */
  @Input() public bgColor: 'grey' | 'white' = 'white';

  /**
   * * Name para o componente de input.
   */
  @Input() public name!: string;

  /**
   * * Índice selecionado por padrão.
   */
  @Input() public indexSelected: number = 0;

  /**
   * * Evento a ser chamado ao trocar de aba.
   */
  @Output() public onchangetab: EventEmitter<number> = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
    // this.buttons[this.indexSelected].selected = true;
  }

  onChangeTab(index: number): void {
    if (index >= 0) {
      this.onchangetab.next(index);
    }
  }



}
